const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Timeline',
	DefaultRenderable: 'Timeline-Display',
	CSS: /*css*/`
		.cst-tl { padding: 8px 0; }
		.cst-tl-item
		{
			display: block;
			padding: 8px 14px;
			cursor: pointer;
			border-left: 3px solid transparent;
			font-size: 13px;
		}
		.cst-tl-item:hover { background: var(--theme-color-background-hover, #eaf2ff); }
		.cst-tl-item.cst-tl-item-active { border-left-color: var(--theme-color-brand-primary, #4a7ad6); background: var(--theme-color-background-hover, #eaf2ff); }
		.cst-tl-prompt-num { font-size: 10px; color: var(--theme-color-text-secondary, #5b6376); text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-tl-prompt-title { font-weight: 500; color: var(--theme-color-text-primary, #1d2230); line-height: 1.3; margin: 2px 0 4px 0; }
		.cst-tl-prompt-meta { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-tl-gap
		{
			display: flex; align-items: center; gap: 8px;
			padding: 4px 14px;
			color: #7a8092;
			font-size: 11px;
			font-style: italic;
		}
		.cst-tl-gap-bar
		{
			display: inline-block;
			height: 2px;
			width: 28px;
			background: repeating-linear-gradient(90deg, #9aa1b1 0 4px, transparent 4px 8px);
		}
	`,
	Templates:
	[
		{
			Hash: 'Timeline-Display',
			Template: /*html*/`
<div class="cst-tl" id="Timeline-Inner"></div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Timeline-Display',
			TemplateHash:   'Timeline-Display',
			ContentDestinationAddress: '#Timeline-Container'
		}
	]
};

class PictViewTimeline extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._buildItems();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_buildItems()
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Prompts) return;

		// Walk turns; emit one item per prompt group, plus a gap marker for human-facing gaps that
		// occur *between* prompt groups (i.e. a gap whose previous turn was inside a different group).
		let tmpHTML = '';
		let tmpRenderedGroups = {};
		for (let i = 0; i < tmpSession.Turns.length; i++)
		{
			let tmpT = tmpSession.Turns[i];
			if (tmpT.Kind === 'gap')
			{
				tmpHTML += '<div class="cst-tl-gap"><span class="cst-tl-gap-bar"></span> idle '
					+ libLayout.formatDuration(tmpT.DurationMs) + '</div>';
				continue;
			}
			if (tmpT.PromptId && !tmpRenderedGroups[tmpT.PromptId])
			{
				tmpRenderedGroups[tmpT.PromptId] = true;
				let tmpGroup = tmpSession.Prompts.find((pG) => pG.PromptId === tmpT.PromptId);
				if (!tmpGroup) continue;
				let tmpIdx = tmpSession.Prompts.indexOf(tmpGroup) + 1;
				let tmpLatency = tmpGroup.ResponseLatencyMs != null
					? 'replied in ' + libLayout.formatDuration(tmpGroup.ResponseLatencyMs)
					: '—';
				tmpHTML += '<div class="cst-tl-item" id="Timeline-Item-' + tmpGroup.PromptId + '" '
					+ 'onclick="_Pict.views.Conversation.scrollToPrompt(\'' + tmpGroup.PromptId + '\')">'
					+ '<div class="cst-tl-prompt-num">Prompt #' + tmpIdx + ' · ' + new Date(tmpGroup.FirstTimestampMs).toLocaleTimeString() + '</div>'
					+ '<div class="cst-tl-prompt-title">' + libLayout.escapeHTML(tmpGroup.Title || '(no text)') + '</div>'
					+ '<div class="cst-tl-prompt-meta">' + libLayout.formatDuration(tmpGroup.TotalDurationMs)
					+ ' · ' + tmpGroup.ToolCallCount + ' tools'
					+ (tmpGroup.AgentCallCount ? ' · ' + tmpGroup.AgentCallCount + ' agents' : '')
					+ ' · ' + tmpLatency
					+ '</div>'
					+ '</div>';
			}
		}
		this.pict.ContentAssignment.assignContent('#Timeline-Inner', tmpHTML);
	}

	highlight(pPromptId)
	{
		let tmpItems = document.querySelectorAll('.cst-tl-item');
		for (let i = 0; i < tmpItems.length; i++) tmpItems[i].classList.remove('cst-tl-item-active');
		let tmpActive = document.getElementById('Timeline-Item-' + pPromptId);
		if (tmpActive) tmpActive.classList.add('cst-tl-item-active');
	}
}

module.exports = PictViewTimeline;
module.exports.default_configuration = _ViewConfiguration;
